export enum WafTab {
  CONFIGURATION = 'CONFIGURATION',
  CUSTOM_WAF = 'CUSTOM_WAF',
  WAF_WHITELIST = 'WAF_WHITELIST',
  WAF_RULE_SETS = 'WAF_RULE_SETS',
}
